var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"mb-2 mt-2 text-uppercase",attrs:{"variant":"dark","block":""},on:{"click":_vm.openModalOferta}},[_vm._v("Ofertar")])}
var staticRenderFns = []

export { render, staticRenderFns }